// Standardised metric colours across the Functional LAB dashboards.
// Any chart that plots one of these metrics MUST import from here so that
// visual identity stays consistent across patient + clinician dashboards.
//
// Palette rules (per product spec):
//   Pain      → Red    (danger / hurts)
//   Wellness  → Blue   (calm / systemic health)
//   Readiness → Green  (go / capacity)
//   Sleep     → Purple (rest / recovery)
//   Stress    → Orange (heat / arousal)
//   Adherence → Teal   (rhythm / consistency)
//   RPE       → Amber (effort)
//   Score     → Functional LAB brand orange
//   Range     → Neutral grey (typical / band)

export const METRIC_COLOR = {
  pain:      "#EF4444",   // red-500
  wellness:  "#3B82F6",   // blue-500
  readiness: "#22C55E",   // green-500
  sleep:     "#8B5CF6",   // violet-500
  stress:    "#F97316",   // orange-500
  adherence: "#14B8A6",   // teal-500
  rpe:       "#F59E0B",   // amber-500
  score:     "#F97316",   // FL brand orange
  compliance:"#14B8A6",   // alias of adherence
  energy:    "#EAB308",   // yellow-500 (secondary)
  confidence:"#22D3EE",   // cyan-400
  range:     "#94A3B8",   // slate-400
};

// iter111.3 · Wellness-trend palette (shared by Today widget + full
// Physical Wellness page). Colours identify metrics only — they do NOT
// imply a clinical safety category. Contrast checked on light + dark.
export const WELLNESS_PALETTE = {
  pain:          "#F87171",   // coral
  fatigue:       "#F59E0B",   // amber
  confidence:    "#34D399",   // emerald
  sleep_quality: "#2DD4BF",   // teal
};

export const METRIC_LABEL = {
  pain: "Pain (0–10)",
  wellness: "Wellness (0–10)",
  readiness: "Readiness (0–10)",
  sleep: "Sleep quality (0–10)",
  stress: "Stress (0–10)",
  adherence: "Adherence (%)",
  rpe: "Session RPE (0–10)",
  score: "Recovery Score (0–100)",
  compliance: "Compliance (%)",
  energy: "Energy (0–10)",
  confidence: "Confidence (0–10)",
};

// Reusable Recharts tooltip content that stays readable across dark + light themes.
export function chartTooltipStyle() {
  return {
    contentStyle: {
      background: "var(--fl-bg-2)",
      border: "1px solid var(--fl-border)",
      borderRadius: 6,
      fontSize: 12,
      color: "var(--fl-text)",
    },
    itemStyle: { color: "var(--fl-text)" },
    labelStyle: { color: "var(--fl-muted)", marginBottom: 4 },
  };
}

// Standardised RAG colours + labels — used across notification, alerts, caseload.
export const RAG = {
  green: { color: "#22C55E", label: "Green — Stable" },
  amber: { color: "#F59E0B", label: "Amber — Monitor" },
  red:   { color: "#EF4444", label: "Red — Immediate review" },
};
